import { useState } from "react";
import { GridRowId } from "@mui/x-data-grid";
import { Box, Tabs, Tab } from "@mui/material";
import {
  AdminTemplate,
  RoleMenuAddModal,
  RoleMenuListingTable,
  RoleMenuTransferTab,
  RoleMenuBulkDeleteTab,
} from "../../components";
import { useAuthorization } from "../../hooks";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

export const SettingsRoleMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [roleMenuData, setRoleMenuData] = useState<any>();
  const [selectedTab, setSelectedTab] = useState(0);
  const { showCreate, showDelete } = useAuthorization();

  const handleAddButton = () => setIsOpen(true);
  const handleRowClick = (data: { id: GridRowId; row: any }) => {
    setIsOpen(true);
    setRoleMenuData(data.row);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Rol Menü Yönetimi",
        onClickAddButton: selectedTab === 0 ? handleAddButton : undefined,
        hideAddButton: selectedTab !== 0,
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="service management tabs"
        >
          <Tab label="Rol Menü Listesi" />
          {showCreate && <Tab label="Toplu Rol Menü Ekleme" />}
          {showDelete && <Tab label="Toplu Rol Menü Silme" />}
        </Tabs>
      </Box>

      <TabPanel value={selectedTab} index={0}>
        <RoleMenuListingTable isMenuOpen={isOpen} onRowClick={handleRowClick} />
      </TabPanel>

      {showCreate && (
        <TabPanel value={selectedTab} index={1}>
          <RoleMenuTransferTab />
        </TabPanel>
      )}

      {showDelete && (
        <TabPanel value={selectedTab} index={showCreate ? 2 : 1}>
          <RoleMenuBulkDeleteTab />
        </TabPanel>
      )}

      {isOpen && (
        <RoleMenuAddModal
          roleMenu={roleMenuData}
          onClose={() => {
            setIsOpen(false);
            setRoleMenuData(undefined);
          }}
          title={roleMenuData ? "Rol Menü Güncelle" : "Rol Menü Ekle"}
          isOpen={isOpen}
        />
      )}
    </AdminTemplate>
  );
};
